export default {
  // Navbar
  'nav.home': '홈',
  'nav.packaging': '제품',
  'nav.customization': '후가공',
  'nav.aiPreview': 'AI 미리보기',
  'nav.quotation': '견적',
  'nav.howItWorks': '이용방법',
  'nav.supplierNetwork': '제조 연합',
  'nav.qualityControl': '품질관리',
  'nav.aboutUs': '회사소개',
  'nav.contact': '문의',
  'nav.signIn': '로그인',
  'nav.getQuote': '견적받기',
  'nav.uploadImage': '이미지 업로드',
  'nav.language': '언어',
  'nav.currency': '통화',

  // Hero
  'hero.badge': '글로벌 B2B 화장품 용기 포털',
  'hero.title': '검증된 중국 공급업체에서 화장품 용기를 찾고 커스터마이징하세요',
  'hero.subtitle': '수천 개의 화장품 용기를 검색하고, 옵션을 비교하며, 후가공을 미리 보고, 한 곳에서 신뢰할 수 있는 B2B 견적을 요청하세요.',
  'hero.quickLinks': '인기',
  'hero.loading': '로딩 중...',
  'hero.cta.browse': '용기 둘러보기',
  'hero.cta.upload': '참고 이미지 업로드',
  'hero.cta.quote': '견적 받기',
  'hero.cta.searchByPhoto': '사진으로 검색',
  'hero.searchByPhoto.title': '사진으로 검색',
  'hero.searchByPhoto.dragDrop': '이미지를 여기에 드래그하거나 클릭하여 업로드하세요',
  'hero.searchByPhoto.maxSize': '모든 이미지 형식 지원, 최대 10MB',
  'hero.searchByPhoto.or': '또는',
  'hero.searchByPhoto.upload': '이미지 업로드',
  'hero.searchByPhoto.takePhoto': '사진 촬영',

  // Announcement
  'announcement.label': '공지사항',
  'announcement.viewAll': '전체보기',

  // Value Cards
  'value.sectionLabel': '왜 GBCOSPACK인가',
  'value.sectionTitle': '우리의 강점',
  'value.sectionSubtitle': '전문적이고 신뢰할 수 있는 파트너',
  'value.suppliers.title': '1,000+ 공급업체 네트워크',
  'value.suppliers.desc': '중국 전역의 검증된 포장 제조업체에 접근하여 표준화된 제품 데이터와 투명한 가격을 확인하세요.',
  'value.moq.title': '낮은 MOQ 옵션',
  'value.moq.desc': '스타트업, 샘플, 시장 테스트에 적합한 소량 최소 주문 수량을 제공하는 공급업체를 찾으세요.',
  'value.ai.title': 'AI 후가공 미리보기',
  'value.ai.desc': '샘플 주문 전에 글로시 캡, 프로스티드 바디, 메탈릭 마감, 매트 텍스처가 어떻게 보이는지 확인하세요.',
  'value.transparent.title': '투명한 견적 및 품질관리',
  'value.transparent.desc': '후가공 비용을 포함한 상세 견적을 받고, 생산의 모든 단계에서 품질 관리를 추적하세요.',

  // Categories
  'categories.subtitle': '우리의 제품',
  'categories.title': '카테고리별 둘러보기',
  'categories.airless': '에어리스 병',
  'categories.pump': '펌프 병',
  'categories.dropper': '드로퍼 병',
  'categories.cream': '크림 단지',
  'categories.tubes': '튜브',
  'categories.cushion': '쿠션 / 컴팩트 케이스',
  'categories.lip': '립 / 메이크업 포장',
  'categories.refill': '리필 용기',
  'categories.eco': '에코 포장',
  'categories.viewAll': '전체 제품 보기',
  'categories.browse': '둘러보기',
  'categories.empty': '등록된 제품이 없습니다.',

  // Search
  'search.quickTitle': '빠른 검색',
  'search.placeholder': '제품명, 소재, 키워드로 검색하세요...',
  'search.visual': '사진으로 검색',
  'search.button': '검색',
  'search.dropHere': '이미지를 끌어다 놓으세요',
  'search.searchingByImage': '이미지 기반 검색 중...',
  'search.imageSearchResult': '{{count}}개의 유사 제품을 찾았습니다',
  'search.imageSearchFailed': '이미지 검색에 실패했습니다. 다시 시도해 주세요.',
  'search.imageSearchUnavailable': '이미지 검색 서버가 현재 사용 불가능합니다.',
  'search.apiRouteNotFound': 'API 경로를 찾을 수 없습니다. Cursor API 경로 /api/customer/image-search 및 프록시 설정을 확인해주세요.',
  'search.browseInstead': '제품 목록을 둘러보세요.',
  'search.noSimilarProducts': '유사한 제품을 찾을 수 없습니다. 다른 이미지를 시도해 보세요.',
  'search.searchByImageTitle': '이미지로 검색',
  'search.searchByImageDesc': '참고 이미지를 업로드하여 유사한 포장을 찾아보세요.',
  'search.imageSearchSubmitted': '이미지가 업로드되었습니다. 결과 페이지로 이동 중...',
  'search.viewResults': '결과 보기',
  'search.dismiss': '닫기',
  'search.upload': '업로드',
  'search.camera': '카메라',
  'search.cancel': '취소',
  'search.findSimilar': '유사 제품 찾기',
  'search.retake': '다시 촬영',
  'search.reupload': '다시 업로드',
  'search.browseAll': '전체 제품 보기',
  'search.bannerTitle': '브랜드에 맞는 화장품 용기를 찾고 계신가요?',
  'search.bannerDesc': '다양한 소재와 디자인의 20,000개 이상의 화장품 용기를 둘러보고, GBCOSPACK의 원스톱 B2B 소싱 서비스를 통해 맞춤 후가공 견적을 받아보세요.',

  // AI Preview
  'aiPreview.label': 'AI 기술',
  'aiPreview.title': '샘플링 전에 후가공을 미리보세요',
  'aiPreview.subtitle': '디자인을 업로드하고 다양한 마감 처리가 용기를 어떻게 변화시키는지 몇 초 만에 확인하세요.',
  'aiPreview.glossy': '글로시 캡',
  'aiPreview.glossy.desc': '프리미엄 느낌을 위한 고광택 반사 마감',
  'aiPreview.frosted': '프로스티드 바디',
  'aiPreview.frosted.desc': '우아한 반투명 매트 텍스처',
  'aiPreview.metallic': '메탈릭 마감',
  'aiPreview.metallic.desc': '고급스러운 금속 질감 표면 처리',
  'aiPreview.matte': '소프트터치 매트',
  'aiPreview.matte.desc': '벨벳 같은 촉감 코팅 경험',
  'aiPreview.color': '컬러 체인지',
  'aiPreview.color.desc': '맞춤 팬톤 매칭 및 그라데이션',
  'aiPreview.uv': 'UV 코팅',
  'aiPreview.uv.desc': '고광택 보습 느낌의 표면 보호층',
  'aiPreview.embossed': '엠보싱 텍스처',
  'aiPreview.embossed.desc': '3D 입체 패턴과 촉각적인 돌출 표면',
  'aiPreview.pearl': '펄 쉬머',
  'aiPreview.pearl.desc': '오팔빛 무지개 빛 반사 마감',
  'aiPreview.tryNow': '커스텀 마감 둘러보기',

  // CTA
  'cta.label': '기업 솔루션',
  'cta.title': '대량 조달을 위한 전담 지원',
  'cta.desc': '전담 계정 매니저가 맞춤 사양, 대량 협상, 엔드투엔드 물류를 지원합니다. 초기 문의부터 최종 배송까지 소싱 워크플로우 전체를 관리해 드립니다.',
  'cta.button': '영업팀에 문의',

  // Quotation Process
  'quotation.title': '주문 방법',
  'quotation.subtitle': '6개의 간단한 단계로 발견부터 배송까지',
  'quotation.step1': '제품 선택',
  'quotation.step1.desc': '수천 개의 용기를 둘러보고 완벽한 제품을 찾으세요',
  'quotation.step2': '후가공 선택 (선택사항)',
  'quotation.step2.desc': '캡 스타일, 색상, 텍스처, 데코레이션을 선택하세요',
  'quotation.step3': '견적 요청',
  'quotation.step3.desc': 'MOQ 및 납기를 포함한 투명한 가격을 받으세요',
  'quotation.step4': '샘플 제작 (선택사항)',
  'quotation.step4.desc': '대량 생산 전 실제 샘플을 검토하세요',
  'quotation.step5': '주문 확정',
  'quotation.step5.desc': '안전한 결제와 계약으로 주문을 확정하세요',
  'quotation.step6': '품질관리 및 배송',
  'quotation.step6.desc': '품질 검수와 글로벌 배송까지 문 앞으로',

  // Trust
  'trust.label': '브랜드가 신뢰하는 이유',
  'trust.title': '글로벌 화장품 브랜드와 검증된 중국 포장 공급업체 간의 간극을 메워, 소싱을 투명하고 효율적이며 신뢰할 수 있게 만듭니다.',
  'trust.suppliers': '검증된 공급업체',
  'trust.suppliers.desc': '네트워크에 참여하기 전 모든 공장이 감사 및 검증을 거칩니다.',
  'trust.data': '표준화된 데이터',
  'trust.data.desc': '모든 제품은 쉬운 비교를 위한 통일된 사양 시트를 사용합니다.',
  'trust.price': '투명한 가격',
  'trust.price.desc': '숨겨진 비용 없이. 전체 비용 내역을 미리 확인하세요.',
  'trust.qc': '품질관리 체크리스트',
  'trust.qc.desc': '공장 및 선적 전 다단계 품질 관리.',
  'trust.delivery': '글로벌 배송',
  'trust.delivery.desc': '50개국 이상을 위한 도어투도어 물류 지원.',
  'trust.stat.suppliers': '1,000+',
  'trust.stat.suppliers.label': '검증된 공급업체',
  'trust.stat.products': '50,000+',
  'trust.stat.products.label': '제품 SKU',
  'trust.stat.countries': '50+',
  'trust.stat.countries.label': '서비스 국가',
  'trust.stat.satisfaction': '98%',
  'trust.stat.satisfaction.label': '고객 만족도',

  // Testimonial
  'testimonial.title': '고객의 소리',
  'testimonial.rating': '4.9 / 5.0',
  'testimonial.review1': '"PackVerse는 우리 스킨케어 라인에 필요한 정확한 에어리스 병을 찾는 데 도움을 주었습니다. AI 미리보기 기능은 공급업체와의 수주간 왔다갔다 할 시간을 절약해 주었습니다. 샘플은 10일 만에 받았고 첫 주문은 4주 만에 진행했습니다."',
  'testimonial.author1': '김사라',
  'testimonial.role1': '설립자, 뤼미에르 뷰티',
  'testimonial.review2': '"동남아 브랜드를 대상으로 하는 OEM 기업으로서, 낮은 MOQ의 신뢰할 수 있는 포장 소스가 필요합니다. 이 플랫폼은 업계에 꼭 필요한 것이었습니다."',
  'testimonial.author2': '마크 탄',
  'testimonial.role2': '구매 디렉터, 아세안 코스모 OEM',

  // Newsletter
  'newsletter.label': '정보 구독',
  'newsletter.title': '뉴스레터 구독하기',
  'newsletter.subtitle': '최신 포장 트렌드, 신규 공급업체 소식, 업계 인사이트를 이메일로 받아보세요.',
  'newsletter.placeholder': '이메일 주소를 입력하세요',
  'newsletter.button': '구독하기',
  'newsletter.success': '구독해 주셔서 감사합니다!',
  'newsletter.error': '유효한 이메일 주소를 입력해 주세요.',

  // Footer
  'footer.company': '회사',
  'footer.about': '회사소개',
  'footer.careers': '채용',
  'footer.press': '보도자료',
  'footer.blog': '블로그',
  'footer.packaging': '용기',
  'footer.browse': '전체 보기',
  'footer.categories': '카테고리',
  'footer.others': '기타',
  'footer.customization': '후가공',
  'footer.finishing': '마감 옵션',
  'footer.aiPreview': 'AI 미리보기',
  'footer.design': '디자인 지원',
  'footer.quote': '견적',
  'footer.request': '견적 요청',
  'footer.moq': 'MOQ 안내',
  'footer.pricing': '가격 안내',
  'footer.support': '고객지원',
  'footer.help': '고객센터',
  'footer.shipping': '배송 안내',
  'footer.returns': '반품 정책',
  'footer.terms': '이용약관',
  'footer.privacy': '개인정보처리방침',
  'footer.contact': '문의하기',
  'footer.rights': '모든 권리 보유.',
  'footer.brand': 'PackVerse',
  'footer.tagline': '글로벌 화장품 용기 소싱 포털',
};